var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.9 595.3",
    enableBackground: "new 0 0 841.9 595.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    display: "inline",
    d: "M670,234.5v-81.2C670,68.8,601.2,0,516.6,0S363.3,68.8,363.3,153.3v108.2 c0,14.9,12.1,27.1,27.1,27.1c14.9,0,27.1-12.1,27.1-27.1V153.3c0-54.7,44.5-99.2,99.2-99.2s99.2,44.5,99.2,99.2v81.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_517_",
    display: "inline",
    d: "M375.8,234.5h-45.1c-14.9,0-27.1,12.1-27.1,27.1v306.7c0,14.9,12.1,27.1,27.1,27.1h360.8 c14.9,0,27.1-12.1,27.1-27.1V261.6c0-14.9-12.1-27.1-27.1-27.1H430"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M619.7,261.8V208c0-55-44.7-99.7-99.7-99.7 c-55,0-99.7,44.7-99.7,99.7v53.8"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M257.7,266.5h-17.7c-10.2,0-18.4,8.2-18.4,18.4 v182.5c0,10.2,8.2,18.4,18.4,18.4h234.7c10.1,0,18.4-8.2,18.4-18.4V284.9c0-10.2-8.3-18.4-18.4-18.4h-17.7"
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    x1: 420.3,
    y1: 266.5,
    x2: 294.5,
    y2: 266.5
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M457.1,266.5v-53.8c0-34.7,28.2-62.9,62.9-62.9 c34.7,0,62.9,28.2,62.9,62.9v53.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M420.3,266.5H294.5h-54.5c-10.2,0-18.4,8.2-18.4,18.4v182.5c0,10.2,8.2,18.4,18.4,18.4h234.7c10.1,0,18.4-8.2,18.4-18.4 V284.9c0-10.2-8.3-18.4-18.4-18.4h-17.7h0v-53.8c0-34.7,28.2-62.9,62.9-62.9c34.7,0,62.9,28.2,62.9,62.9v53.8h36.8v-53.8 c0-55-44.7-99.7-99.7-99.7c-55,0-99.7,44.7-99.7,99.7V266.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.7a1d9b4e.svg";
export { ForwardRef as ReactComponent };